'use strict';

const ajax = require('./modules/ajax'),
    appendParamToURL = require('./modules/util/appendParamToURL'),
    _isString = require('lodash/isString'),
    _merge = require('lodash/merge'),
    imagesLoaded = require('imagesloaded');

const dialog = {
    def: {
        $headerElement: $('header.header')
    },
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        let $target, id;

        if (_isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params, target) {
        let position;

        const contentTarget = target || this.$container;

        if (!contentTarget) {
            return;
        }
        const content = params.content || params.html;
        if (!content) {
            return;
        }
        contentTarget.empty().html(content);

        if (!contentTarget.dialog('isOpen')) {
            contentTarget.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }

        if (!position) {
            position = this.settings.position;
        }

        imagesLoaded(contentTarget).on('done', function () {
            contentTarget.dialog('option', 'position', position);
        }.bind(this));

        const callback = (typeof params.callback === 'function') ? params.callback : function () {return;};
        callback();

        $('.js-bonus-product-dialog-wrapper').addClass('js-gwp-open');

        if ($('.gwp-popup-padding').length > 0) {
            $('.js-bonus-product-dialog-wrapper').addClass('no-padding');
            $('.gwp-popup-padding').closest('.ui-dialog').addClass('no-padding');
            $('.gwp-popup-padding').closest('.ui-dialog').css('width', '650px');
        }

        const popupLabelText = $('.js-close-popup-text').html();
        $('.ui-dialog-titlebar-close').attr('aria-label', popupLabelText);
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }

        if (params.url) {
            params.url = appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                dialogTarget: params.target,
                callback: function (response, target) {
                    params.content = response;
                    this.openWithContent(params, target);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        } else {
            this.$container.dialog('open');
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');

        $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');

    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        closeText: '',
        autoOpen: false,
        height: 'auto',
        draggable: false,
        resizable: false,
        modal: false,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        title: '',
        width: '800',
        open: function () {
            //Show dressed down version of the header to disable unwanted navigation (except cookie bar dialog).
            if (!$(this).parent().hasClass('cookie-bar')){
                dialog.def.$headerElement.addClass('header--empty');

                const current = $(this);
                $('body').on('click', '.ui-widget-overlay', function(){
                    current.dialog('close');
                });
            }
        },
        close: function () {
            $(this).dialog('close');
            if (!$('.pt_privacy').length && !$('.js-accept-cookies').length) {
                dialog.def.$headerElement.removeClass('header--empty');
            }
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

$(document).on('click', '.ui-dialog-titlebar-close, .js-close-bonus-popup', function() {
    $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');
});

$(document).on('keyup', function(e) {
    if (e.which == 27 && $('.js-bonus-product-dialog-wrapper').hasClass('js-gwp-open')){
        $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');
   }
});

module.exports = dialog;
